import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AdminTables } from "@/components/admin/AdminTables";

const Login = ({ onDone }) => {
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.post("/auth/login", f); onDone(data); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-[28px] bg-[#0E101D] border border-white/10 p-8">
      <img src="/brand/logo.png" alt="ZoopUp" className="h-10 w-auto" />
      <h1 className="mt-6 font-display font-extrabold text-2xl">Staff login</h1>
      <input data-testid="admin-email-input" type="email" className="field mt-6" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required />
      <input data-testid="admin-password-input" type="password" className="field mt-4" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
      <button data-testid="admin-login-btn" disabled={busy} className="btn-zoop w-full mt-6 rounded-full py-3.5 font-display font-bold inline-flex items-center justify-center gap-2">
        {busy && <Loader2 className="animate-spin" size={16} />} Sign in
      </button>
      <Link to="/" className="block mt-5 text-center text-sm text-slate-400 hover:text-white">← Back to site</Link>
    </form>
  );
};

export default function Admin() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };

  if (user === null) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin" /></div>;
  if (!user) return <main className="min-h-screen flex items-center justify-center px-5"><Login onDone={setUser} /></main>;
  return (
    <main data-testid="admin-dashboard" className="min-h-screen max-w-[1400px] mx-auto px-5 md:px-10 py-10">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <img src="/brand/logo.png" alt="ZoopUp" className="h-9 w-auto" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400 hidden sm:inline">Dashboard</span>
        </div>
        <button data-testid="admin-logout-btn" onClick={logout} className="btn-ghost rounded-full px-4 py-2 text-sm inline-flex items-center gap-2"><LogOut size={14} /> Logout</button>
      </div>
      <AdminTables />
    </main>
  );
}
